import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrl: './page-not-found.component.css'
})
export class PageNotFoundComponent {
  env = environment
}
